import { fetcher } from "@/services/fetcher";
export const profileService = {
    signUp(data) {
        return fetch('/api/v1/users/register', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    },
    signIn(data) {
        return fetch('/api/v1/users/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    },
    verify(verificationToken) {
        return fetch('/api/v1/users/verify', {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ verificationToken })
        });
    },
    loadProfile() {
        return fetch('/api/v1/users/profile');
    },
    signOut() {
        return fetch('/api/v1/users/sign-out', {
            method: 'PATCH',
        });
    },
    updateProfile(data) {
        return fetch('/api/user/profile', {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
    },
    restorePassword(data) {
        return fetcher('/api/v1/users/restore_password', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
    }
};
